


import { createContext, useContext, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { getMyPermissions } from "../redux/actions/authActions";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem("token"));
  const [role, setRole] = useState(localStorage.getItem("role") || null);

  const dispatch = useDispatch();

  const login = (token, userRole) => {
    localStorage.setItem("token", token);
    localStorage.setItem("role", userRole);
    setIsAuthenticated(true);
    setRole(userRole);
    dispatch(getMyPermissions()); // Fetch on login
  };

  const logout = () => {
    localStorage.clear();
    setIsAuthenticated(false);
    setRole(null);
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    const storedRole = localStorage.getItem("role");

    if (token) {
      setIsAuthenticated(true);
      setRole(storedRole);
      dispatch(getMyPermissions()); // Re-fetch on page reload
    } else {
      logout();
    }
  }, [dispatch]);

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout, role }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
